require('angular-material')
// the following code is copied from node_modules\angular-material\angular-material.js
function colorToRgbaArray (clr) {
  if (angular.isArray(clr) && clr.length === 3) return clr
  if (/^rgb/.test(clr)) {
    return clr
      .replace(/(^\s*rgba?\(|\)\s*$)/g, '')
      .split(',')
      .map(function (value, i) {
        return i === 3 ? parseFloat(value) : parseInt(value, 10)
      })
  }
  if (clr.charAt(0) === '#') clr = clr.substring(1)
  if (!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr)) return

  var dig = clr.length / 3
  var red = clr.substr(0, dig)
  var grn = clr.substr(dig, dig)
  var blu = clr.substr(dig * 2)
  if (dig === 1) {
    red += red
    grn += grn
    blu += blu
  }
  return [parseInt(red, 16), parseInt(grn, 16), parseInt(blu, 16)]
}
var DARK_CONTRAST_COLOR = colorToRgbaArray('rgba(0,0,0,0.87)')
var LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgba(255,255,255,0.87)')
var STRONG_LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgb(255,255,255)')

var DARK_CONTRAST_OPACITY = {
  icon: 0.54,
  secondary: 0.54,
  disabled: 0.38,
  hint: 0.38,
  divider: 0.12
}

var LIGHT_CONTRAST_OPACITY = {
  icon: 0.87,
  secondary: 0.7,
  disabled: 0.5,
  hint: 0.5,
  divider: 0.12
}

// Icon opacity values (active/inactive) from
// https://material.io/archive/guidelines/style/color.html#color-usability
var STRONG_LIGHT_CONTRAST_OPACITY = {
  icon: 1.0,
  secondary: 0.7,
  disabled: 0.5,
  hint: 0.5,
  divider: 0.12
}
export function sanitizePalette (palette) {
  var defaultContrast = palette.contrastDefaultColor
  var lightColors = palette.contrastLightColors || []
  var strongLightColors = palette.contrastStrongLightColors || []
  var darkColors = palette.contrastDarkColors || []

  // These colors are provided as space-separated lists
  if (typeof lightColors === 'string') lightColors = lightColors.split(' ')
  if (typeof strongLightColors === 'string')
    strongLightColors = strongLightColors.split(' ')
  if (typeof darkColors === 'string') darkColors = darkColors.split(' ')

  // Cleanup after ourselves
  delete palette.contrastDefaultColor
  delete palette.contrastLightColors
  delete palette.contrastStrongLightColors
  delete palette.contrastDarkColors

  /**
   * @param {string} hueName
   * @return {'dark'|'light'|'strongLight'}
   */
  function getContrastType (hueName) {
    if (
      defaultContrast === 'light'
        ? darkColors.indexOf(hueName) !== -1
        : lightColors.indexOf(hueName) === -1 &&
          strongLightColors.indexOf(hueName) === -1
    ) {
      return 'dark'
    }
    if (strongLightColors.indexOf(hueName) !== -1) {
      return 'strongLight'
    }
    return 'light'
  }

  /**
   * @param {'dark'|'light'|'strongLight'} contrastType
   * @return {[number, number, number]} [red, green, blue] array
   */
  function getContrastColor (contrastType) {
    switch (contrastType) {
      default:
      case 'strongLight':
        return STRONG_LIGHT_CONTRAST_COLOR
      case 'light':
        return LIGHT_CONTRAST_COLOR
      case 'dark':
        return DARK_CONTRAST_COLOR
    }
  }

  /**
   * @param {'dark'|'light'|'strongLight'} contrastType
   * @return {{secondary: number, divider: number, hint: number, icon: number, disabled: number}}
   */
  function getOpacityValues (contrastType) {
    switch (contrastType) {
      default:
      case 'strongLight':
        return STRONG_LIGHT_CONTRAST_OPACITY
      case 'light':
        return LIGHT_CONTRAST_OPACITY
      case 'dark':
        return DARK_CONTRAST_OPACITY
    }
  }
  // Change { 'A100': '#fffeee' } to { 'A100': { value: '#fffeee', contrast:DARK_CONTRAST_COLOR }
  angular.forEach(palette, function (hueValue, hueName) {
    if (angular.isObject(hueValue)) return // Already converted
    // Map everything to rgb colors
    var rgbValue = colorToRgbaArray(hueValue)
    if (!rgbValue) {
      throw new Error(
        "Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected."
          .replace('%1', hueValue)
          .replace('%2', palette.name)
          .replace('%3', hueName)
      )
    }

    var contrastType = getContrastType(hueName)
    palette[hueName] = {
      hex: palette[hueName],
      value: rgbValue,
      contrastType: contrastType,
      contrast: getContrastColor(contrastType),
      opacity: getOpacityValues(contrastType)
    }
  })
}
